<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">

      </b-col>

    </b-row>
    <b-row style="background: #fff;padding: 15px; margin: 10px;">

      <div class="demo-spacing-0 my-2">
        <b-alert
            variant="primary"
            show
        >
          <div class="alert-body">
            <span><strong>نکته : </strong> هزینه نهایی براساس قیمت های تقویم حساب میگردد.</span>
          </div>
        </b-alert>
      </div>

          <b-form-group class="col-md-12">
            <label for="admin_user" class="text-capitalize">* انتخاب  مهمان (اگه در لیست نیست بعنوان کاربر آن را ثبت نمایید) :</label>
            <v-select
                id="owner_user"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="orderRequestInput.user_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :get-option-label="(option) => option.full_name"
                :reduce="(user) => user.id"
                :options="users"

                placeholder="برای جستجو تایپ کنید"
            >
              <template #option="{ full_name, mobile }">
                {{ full_name }}
                <br />
                <cite>{{ mobile }}</cite>
              </template>
            </v-select>
          </b-form-group>

          <b-form-group class="col-md-12">
            <label for="admin_user" class="text-capitalize">* انتخاب اقامتگاه  :</label>
            <v-select
                id="owner_user"
                :components="{ OpenIndicator }"
                class="bg-white"
                :clearable="false"
                v-model="orderRequestInput.orderable_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :get-option-label="(option) => option.name"
                :reduce="(residence) => residence.id"
                :options="residences"

                placeholder="برای جستجو تایپ کنید"
            >
              <template #option="{ name,id }" style="direction: ltr">
                <cite>{{name}}</cite>

              </template>
            </v-select>
          </b-form-group>

          <b-form-group  class="col-md-6">
            <label for="name" class="text-capitalize">* تاریخ شروع : </label>
            <b-form-input class="my-custom-editable-input1" type="text" />
            <date-picker
                auto-submit
                clearable
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                v-model="orderRequestInput.checkin"
                custom-input=".my-custom-editable-input1"
            />
          </b-form-group>
          <b-form-group  class="col-md-6">
            <label for="name" class="text-capitalize">* تاریخ پایان : </label>
            <b-form-input class="my-custom-editable-input2" type="text" />
            <date-picker
                auto-submit
                clearable
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
                v-model="orderRequestInput.checkout"
                custom-input=".my-custom-editable-input2"
            />
          </b-form-group>

      <b-form-group class="col-md-3">
        <label for="adult" class="text-capitalize"
        > تعداد نفرات بزرگسال<span class="text-danger">*</span></label
        >
        <b-form-input
            lazy
            type="number"
            v-model="orderRequestInput.guests.adult"
            id="adult"
            key="adult"
            placeholder="  تعداد نفرات بزرگسال"
        />
      </b-form-group>
      <b-form-group class="col-md-3">
        <label for="child" class="text-capitalize"
        > تعداد نفرات کودک<span class="text-danger">*</span></label
        >
        <b-form-input
            lazy
            type="number"
            v-model="orderRequestInput.guests.child"
            id="child"
            key="child"
            placeholder="  تعداد نفرات کودک"
        />
      </b-form-group>
      <b-form-group class="col-md-3">
        <label for="baby" class="text-capitalize"
        > تعداد نوزاد<span class="text-danger">*</span></label
        >
        <b-form-input
            lazy
            type="number"
            v-model="orderRequestInput.guests.baby"
            id="baby"
            key="baby"
            placeholder="  تعداد نفرات نوزاد"
        />
      </b-form-group>
      <b-form-group class="col-md-3">
        <label for="adult" class="text-capitalize"
        > تعداد نفرات حیوان<span class="text-danger">*</span></label
        >
        <b-form-input
            lazy
            type="number"
            v-model="orderRequestInput.guests.pet"
            id="adult"
            key="adult"
            placeholder="  تعداد نفرات حیوان"
        />
      </b-form-group>

      <b-form-group class="col-md-12">
        <label for="residence_area" class="text-capitalize">
           وضعیت پرداخت : گزینه paid را انتخاب نمایید.<span class="text-danger">*</span>

        </label>
        <v-select
            id="residence_area"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            v-model="orderRequestInput.status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusPayment"
        />
      </b-form-group>

      <div class="d-flex align-items-center justify-content-end px-2 py-1">
        <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
        >
          {{ $t("cancel") }}
        </b-button>
        <b-button variant="primary" @click="submitForm()">
          <div v-if="submitLoading" class="px-1">
            <b-spinner small style="width: 1.3rem; height: 1.3rem" />
            <span class="sr-only">Loading...</span>
          </div>
          <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
        </b-button>
      </div>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BBadge, BModal, BCardText, BAlert,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    BAlert,
    BCardText,
    BModal,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      orders: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      statusPayment:[
        "pending",
        "ready_to_pay",
        "paid",
        "canceled",
        "rejected"
      ],
      tableHeadings: [
        {
          title: "شماره رزرو",
          slug: "name",
          sortable: true,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "میزبان",
          slug: "host",
          sortable: true,
        },
        {
          title: "مهمان",
          slug: "guest",
          sortable: true,
        },
        {
          title: "سفارش",
          slug: "order",
          sortable: true,
        },
        {
          title: "تاریخ درخواست",
          slug: "created_at",
          sortable: true,
        },
        {
          title: "وضعیت پرداخت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },


      orderRequestInput: {
        id: "",
        user_id: "",
        checkin: "",
        checkout: "",
        orderable_type: "residence",
        orderable_id: "",
        guests: {
          adult:1,
          child:0,
          baby:0,
          pet:0,
        },
        discount_code:"",
        instant_type:false,
        status: "",

      },
      users: [],
      residences: [],
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getUsers();
    this.getExperiences();
    // this.getCompanies();
  },
  watch: {
    searchInput(value) {
      this.page = 1;

    },
    perPage(value) {
      this.page = 1;

    },
    page(value) {

    },
  },
  methods: {
    getUsers(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "/admin/users/get_total_users",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.users = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    getExperiences(search, loading) {
      if (typeof this.usersCancelToken != typeof undefined) {
        this.usersCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.usersCancelToken = this.$http.CancelToken.source();

      let data = {
        search: this.searchInput,
        per_page: this.perPage,
        page: this.page,
        sort_by: this.sortBy,
        sort_dir: this.sortDir,
        paginate:true
      };
      const requestData = {
        method: "get",
        url: "/site/residences/sitemap",
        params: data,
        // cancelToken: this.usersCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.residences = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getCounties();
    },
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },

    submitForm() {
      if (this.submitLoading) return;
      /*
            let errorMessage = null;

            if (!errorMessage && !this.orderInput.name) {
              errorMessage = "لطفا نام سفارش را وارد کنید";
            }
            if (!errorMessage && this.orderInput.name.length < 2) {
              errorMessage = "نام سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }
            if (!errorMessage && !this.orderInput.slug) {
              errorMessage = "لطفا اسلاگ سفارش را وارد کنید";
            }
             if (!errorMessage && this.orderInput.slug.length < 2) {
              errorMessage = "اسلاگ سفارش نمی تواند کمتر از دو کاراکتر باشد";
            }


            if (errorMessage) {
              this.$bvToast.toast(errorMessage, {
                title: this.$t("Error"),
                variant: "danger",
                solid: true,
              });
              return;
            }
      */

      this.submitLoading = true;

      const requestData = {
        method: "post",
        url: `/admin/reserveSpace`,
        data: this.orderRequestInput,
      };
      this.$http(requestData)
          .then((response) => {
            let message = "سفارش با موفقیت اضافه شد";
          //  if (this.editMode) message = "سفارش با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            /*     if (!this.editMode && this.orders && this.orders.length > 0) {
                   this.$refs.ordersPaginationComponent.clear();
                   // this.$refs.ordersSearchComponent.clear();
                   this.$refs.ordersTableHeadComponent.clear();
                   this.page = 1;
                   this.searchInput = "";
                   this.sortBy = "";
                   this.sortDir = "";
                 }*/

            this.submitLoading = false;
            this.formModal = false;
            this.$router.back();
          })
          .catch((err) => {
            let message = "خطا در ایجاد سفارش";
            if (this.editMode) message = "خطا در ویرایش سفارش";
            if (err.response && err.response.data && err.response.data.message)
              message = err.response.data.message;

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },


  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
